// Where we remember the last chunk-error reload. Written to both places every
// time: sessionStorage, and the URL so the reload requests a new query string.
// The param is left in place afterwards — stripping it makes the browser URL
// disagree with Inertia's page.url, and Inertia then pushes the old URL back as a
// new history entry, which strands the Back button.
export const RELOAD_GUARD_KEY = "chunkErrorReloadAt";
export const RELOAD_PARAM = "_cr";

// Reload at most once per 10s so a truly broken chunk can't loop forever.
export const RELOAD_PAGE_AT_MOST_MS = 10_000;

// Must not match isChunkLoadError, or the boundary handler retries this instead
// of reporting it.
export const RECOVERY_FAILED_MESSAGE =
  "Chunk failed to load again after a recovery reload.";
